export const productHighlights = {
  1: {
    text: 'Hot',
    className:
      'border-rose-500 bg-gradient-to-r from-rose-600 to-red-600 text-white shadow-lg shadow-rose-500/30 dark:from-rose-500 dark:to-red-500 dark:shadow-rose-400/40',
  },
  2: {
    text: 'New',
    className:
      'border-violet-500 bg-gradient-to-r from-violet-600 to-purple-600 text-white shadow-lg shadow-violet-500/30 dark:from-violet-500 dark:to-purple-500 dark:shadow-violet-400/40',
  },
  3: {
    text: '10% Off',
    className:
      'border-amber-500 bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-lg shadow-amber-500/30 dark:from-amber-500 dark:to-orange-500 dark:shadow-amber-400/40',
  },
};